import { Classes } from '@blueprintjs/core';
import { broker } from '@axo/shared/data-access/types';

interface Props {
  id: number | undefined;
}

export function BrokerName({ id }: Props) {
  return name(id ?? -1);
}

function name(id: number) {
  switch (id) {
    case broker.Broker.Axo:
      return 'Axo';

    case broker.Broker.Zmarta:
      return 'Zmarta';

    default:
      return <em className={Classes.TEXT_MUTED}>Unknown</em>;
  }
}
